export default "__VITE_ASSET__BBRE7qJw__"